import { Config } from '../../node_modules/@cvx/cal';

const calConfig: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: 'localStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: '35b1966d-ba0e-4229-9770-1e90d2bbbfe8',
  redirectUri: 'https://substa-ui-test.azure.chevron.com',
  oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  graphScopes: ['User.Read', 'User.Read.All'],
};

export const environment = {
  calConfig: calConfig,
  production: false,
  envName: 'test',
  apiEndpoint: 'https://substa-dev-fast-api-eqhna7b6bmbucada.southcentralus-01.azurewebsites.net/',
  logging: {
    enabled: true,
    level: 'debug'
  }
};
